import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'reactstrap';
import logo from '../../assets/img/logo-horizontal.png'
import sygnet from '../../assets/img/logo-horizontal.png'

const propTypes = {
     children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
     render() {
          const Configuracion = this.props.Configuracion.Sitio;

          // eslint-disable-next-line
          const { children, ...attributes } = this.props;

          return (
            <footer >
              <div className="container p-4 text-center text-sm-left">
                <Row>
                  <Col md={4} lg={4}>
                    <a target="_self" href="https://shoppingciudadmagica.com.ar/"><img className="img-fluid" src={logo} /></a>
                    <div className="p-2">{Configuracion.ComentarioPiePagina}</div>
                  </Col>

                  <Col md={4} lg={4}>
                    <h2>Contacto</h2>
                    <div className="d-block">

                    {Configuracion.DireccionLocal1 != '' && <div><i className="fa fa-map-marker" aria-hidden="true"></i>{" "}{Configuracion.DireccionLocal1}</div>}
                    {Configuracion.TelefonoLocal1 != '' && <div><a href={`tel:${Configuracion.TelefonoLocal1}`}><i className="fa fa-phone" aria-hidden="true"></i> {Configuracion.TelefonoLocal1}</a></div>}
                    {Configuracion.TelefonoWassapLocal1 != '' && <div><a href={`https://api.whatsapp.com/send?phone=${Configuracion.TelefonoWassapLocal1}`}>¿Estás en tu celular? Contactanos por Whatsapp <i className="fa fa-whatsapp" aria-hidden="true"></i></a></div> }
                    {Configuracion.Correo != '' && <div className="home-footer-email"><a href={`mailto:${Configuracion.Correo}`}><i className="fa fa-envelope-o" aria-hidden="true"></i>{" "}{Configuracion.Correo}</a></div>}

                    {Configuracion.DireccionLocal2 != '' && <div className="mt-2"><i className="fa fa-map-marker" aria-hidden="true"></i>{" "}{Configuracion.DireccionLocal2}</div>}
                    {Configuracion.TelefonoLocal2 != '' && <div><a href={`tel:${Configuracion.TelefonoLocal2}`}><i className="fa fa-phone" aria-hidden="true"></i> {Configuracion.TelefonoLocal2}</a></div>}
                    {Configuracion.TelefonoWassapLocal2 != '' && <div><a href={`https://api.whatsapp.com/send?phone=${Configuracion.TelefonoWassapLocal2}`}>¿Estás en tu celular? Contactanos por Whatsapp <i className="fa fa-whatsapp" aria-hidden="true"></i></a></div> }

                    
                    <div className="mt-2">
                      <i className="fa fa-map-marker" aria-hidden="true"></i>{" "}
                      Esmeralda 802, Bahía Blanca
                    </div>
                    
                    <div className="mt-2"><i className="fa fa-map-marker" aria-hidden="true"></i> 25 de mayo 595, Punta Alta</div>
                    <div><a href="tel:+5492914072506"><i className="fa fa-phone" aria-hidden="true"></i> 291 407-2506</a></div>
                    <div><a href="https://api.whatsapp.com/send?phone=+5492914072506">¿Estás en tu celular? Contactanos por Whatsapp <i className="fa fa-whatsapp" aria-hidden="true"></i></a></div>

                    <div><a target="_blank" href="https://www.instagram.com/shoppingciudadmagica/"> <i className="fa fa-instagram" aria-hidden="true"></i> /shoppingciudadmagica</a></div>
                    </div>

                  </Col>

                  <Col md={4} lg={4}>
                  <div className="d-block mt-4 pr-sm-5 pr-md-0">
                    <p className="m-0"><a target="_self" href="https://shoppingciudadmagica.com.ar/">SHOPPING CIUDAD MÁGICA</a> © {(new Date().getFullYear())}<br/>Todos los Derechos Reservados.</p>
                    </div>
                    <p className="m-0 mb-md-3 mb-lg-0 pr-sm-5 pr-md-0">Desarrollado por <a href="https://www.paradigma.com.ar" className="rounded"><img height={25} src="https://paradigma.com.ar/img/logoParadigmaPie.png"/></a> </p>
                  </Col>
                </Row>
              </div>
            </footer>
          );
     }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultFooter.js